import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideMessage } from 'app/store/fuse/messageSlice';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => {
  const toast = {
    backgroundColor: '#FFFFFF',
    color: theme.palette.text.primary,
    borderLeft: `6px solid ${theme.palette.primary.main}`,
    '& .MuiSnackbarContent-message .MuiIcon-root': { color: theme.palette.primary.main },
  };

  return {
    root: {},
    success: toast,
    error: toast,
    info: toast,
    warning: toast,
  };
});

const variantIcon = {
  success: 'check',
  warning: 'warning',
  error: 'error_outline',
  info: 'info',
};

function FuseMessage() {
  const dispatch = useDispatch();
  const state = useSelector(({ fuse }) => fuse.message.state);
  const { message, ns, ...options } = useSelector(({ fuse }) => fuse.message.options);
  const { t } = useTranslation();

  const classes = useStyles();

  return (
    <Snackbar
      {...options}
      open={state}
      onClose={() => dispatch(hideMessage())}
      classes={{
        root: classes.root,
      }}
      ContentProps={{
        variant: 'body2',
        headlineMapping: {
          body1: 'div',
          body2: 'div',
        },
      }}
    >
      <SnackbarContent
        className={clsx(classes[options.variant])}
        message={
          <div className="flex items-center">
            {variantIcon[options.variant] && <Icon color="inherit">{variantIcon[options.variant]}</Icon>}
            <Typography className="mx-8" style={{ whiteSpace: 'pre-wrap' }}>
              {t(message, { ns })}
            </Typography>
          </div>
        }
        action={[
          options.action,
          <IconButton key="close" aria-label="Close" color="inherit" onClick={() => dispatch(hideMessage())}>
            <Icon>close</Icon>
          </IconButton>,
        ]}
      />
    </Snackbar>
  );
}

export default React.memo(FuseMessage);
